import { useCallback, useState } from "react";
function useItemOnHover(neverHide) {
  const [state, setState] = useState(() => ({
    hover: false,
    visible: false
  }));
  const onEnter = useCallback(function onEnter2() {
    setState((prevState) => ({ ...prevState, hover: true }));
  }, []);
  const onLeave = useCallback(function onLeave2() {
    setState((prevState) => ({ ...prevState, hover: false }));
  }, []);
  const handleChange = useCallback(function onChangeItemVisibility(visibility) {
    setState((prevState) => ({
      ...prevState,
      visible: visibility,
      hover: visibility ? false : prevState.hover
    }));
  }, []);
  return {
    onChangeItemVisibility: handleChange,
    onEnter,
    onLeave,
    visible: neverHide || state.hover || state.visible
  };
}
export {
  useItemOnHover
};
//# sourceMappingURL=useItemOnHover.js.map
